import { endpointWrapper } from 'utils/api/meta.api';

export const DELETE = 'DELETE';

export const fetchWatchlists = () =>
    endpointWrapper({
        domain: 'watchlist/watchlist',
    }).then((resp) =>
        resp.reduce((acc, watchlist) => {
            const { id, action, data } = watchlist;
            if (action !== DELETE)
                acc[id] = {
                    id,
                    action,
                    ...(data && JSON.parse(data)),
                };
            return acc;
        }, {}),
    );

export const createWatchlist = ({ id, action = null, data }) =>
    endpointWrapper({
        domain: `watchlist/watchlist/${id}`,
        data: {
            action,
            ...(data && { data: JSON.stringify(data) }),
        },
    });

export const deleteWatchlist = (options) =>
    createWatchlist({ ...options, action: DELETE });

export const fetchWatchlistItems = () =>
    endpointWrapper({
        domain: 'watchlist/items',
        method: 'GET',
    }).then((resp) =>
        resp.map(({ id, watchlist, modified, data }) => ({
            id,
            watchlist,
            modified,
            ...(data && JSON.parse(data)),
        })),
    );

export const watch = (items) =>
    endpointWrapper({
        domain: 'watchlist/items',
        method: 'POST',
        data: items.map(({ action = null, data, ...restOptions }) => ({
            ...restOptions,
            action,
            ...(data && { data: JSON.stringify(data) }),
        })),
    });

export const unwatch = (items) =>
    watch(
        items.map((options) => ({
            ...options,
            action: DELETE,
        })),
    );

export const createOrUpdatePublishedWatchlist = ({ id, watchlist, read }) => {
    const domain = `watchlist/published_watchlists${id ? `/${id}` : ``}`;
    return endpointWrapper({
        domain,
        data: { watchlist, read },
    });
};

export const fetchPublishedWatchlists = () =>
    endpointWrapper({
        domain: `watchlist/published_watchlists`,
        method: 'GET',
    }).then((resp) => resp);

export const fetchPublishedWatchlist = ({ queryKey }) =>
    endpointWrapper({
        domain: `watchlist/published_watchlists/${queryKey[1]}`,
        method: 'GET',
    })
        .then((resp) => {
            if (!resp) return null;
            const { id, data, items } = resp;
            return {
                id,
                ...(data && JSON.parse(data)),
                items: items.map(({ data: itemData, ...restItem }) => ({
                    ...restItem,
                    ...(itemData && JSON.parse(itemData)),
                })),
            };
        })
        .catch(console.error);
